module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">{{message.text}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/alert/alert.component.html
// module id = ./src/app/shared/alert/alert.component.html
// module chunks = main